import styled from 'styled-components'

const NewsIndividualStyle = styled.div.attrs({})`
	--shareLinkSize: var(--sp4x);
	--shareLinkRight: var(--sp8x);
	--shareLinkPadding: var(--sp3x);
	--socIconHeight: var(--sp10x);
	--socIconWidth: var(--sp6x);

	section {
		display: flex;
		flex-direction: column;

		.back-btn {
			display: flex;
			align-items: center;
			margin: var(--sp6x) 0 var(--sp13x);

			i {
				font-size: var(--sp8x);
				transform: rotate(180deg);
				margin-right: var(--sp4x);
			}
		}

		.top {
			.infos {
				margin-right: var(--sp11x);
				flex: 1;

				.date {
					margin: var(--sp7x) 0 var(--sp32x);
				}

				.social {
					.cont {
						.icon-copy {
							padding: var(--shareLinkPadding) 0;
							font-size: var(--shareLinkSize);
							margin-right: var(--shareLinkRight);
							position: relative;

							&:after {
								content: '';
								position: absolute;
								top: 50%;
								left: 50%;
								height: var(--socIconHeight);
								width: var(--socIconWidth);
								transform: translateX(-50%) translateY(-50%) rotate(36deg);
								border: 1px solid var(--textColor);
								border-radius: 50%;
							}
							&:last-child {
								margin-right: 0;
							}
						}
					}
				}
			}

			.imageCont {
				width: 55.1%;
				padding-top: 36.3%;
			}
		}

		.content {
			max-width: var(--sp149x);
			width: 100%;
			margin: var(--sp13x) auto var(--sp28x);

			p {
				font-size: var(--pM);
				font-family: NotoSansRegular;
				margin-bottom: var(--sp4x);

				strong {
					font-family: NotoSansBold;
				}
			}

			figure {
				margin: 0;
				margin-bottom: var(--sp7x);

				img {
					width: 100%;
					object-fit: contain;
				}
			}

			ul {
				margin-bottom: var(--sp7x);
				padding-left: var(--sp5x);

				li {
					font-size: var(--pM);
					text-transform: uppercase;
					font-family: NotoSansRegular;
					position: relative;
					padding-left: var(--sp7x);

					&:before {
						content: '';
						background-image: url('/images/star.svg');
						background-size: contain;
						width: var(--sp4-5x);
						height: var(--sp4-5x);
						position: absolute;
						top: 50%;
						left: 0;
						transform: translateY(-50%);
					}

					&:not(:last-child) {
						margin-bottom: var(--sp4x);
					}
				}
			}

			ol {
				margin-bottom: var(--sp7x);
				padding-left: var(--sp5x);

				li {
					font-size: var(--pM);
					font-family: GHEAMariamRegular;
					position: relative;
					/* padding-left:var(--sp7x); */

					&:not(:last-child) {
						margin-bottom: var(--sp4x);
					}
				}
			}

			blockquote {
				margin: 0;
				border-left: 1px solid var(--textColor);
				padding-left: var(--sp6x);

				p {
					&:last-child {
						text-transform: uppercase;
						margin-bottom: 0;
					}
				}
			}
		}

		.related-title {
			margin-bottom: var(--sp7x);
		}
	}
	.related {
		border-top: 1px solid var(--textColor);
	}

	.btn-cont {
		margin: var(--sp9x) 0 var(--sp28x);
		display: flex;
		justify-content: center;
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		--shareLinkSize: var(--sp3x);
		--shareLinkRight: var(--sp7x);
		--shareLinkPadding: var(--sp2-5x);
		--socIconHeight: var(--sp8x);
		--socIconWidth: var(--sp4-5x);

		section {
			.back-btn {
				margin: var(--sp5x) 0 var(--sp10x);

				i {
					font-size: var(--sp7x);
					margin-right: var(--sp3x);
				}
			}

			.top {
				.infos {
					margin-right: var(--sp10x);

					.date {
						margin: var(--sp6x) 0 var(--sp23x);
					}
				}

				.imageCont {
					width: 52.9%;
					padding-top: 34.9%;
				}
			}

			.content {
				max-width: var(--sp110x);
				margin: var(--sp10x) auto var(--sp25x);

				p {
					margin-bottom: var(--sp3x);
				}

				figure {
					margin-bottom: var(--sp6x);
				}

				ul {
					margin-bottom: var(--sp6x);
					padding-left: var(--sp4x);

					li {
						padding-left: var(--sp6x);

						&:before {
							width: var(--sp3x);
							height: var(--sp3x);
						}

						&:not(:last-child) {
							margin-bottom: var(--sp3x);
						}
					}
				}

				ol {
					margin-bottom: var(--sp6x);
					padding-left: var(--sp4x);

					li {
						&:not(:last-child) {
							margin-bottom: var(--sp3x);
						}
					}
				}

				blockquote {
					padding-left: var(--sp4x);
				}
			}

			.related-title {
				margin-bottom: var(--sp6x);
			}
		}

		.btn-cont {
			margin: var(--sp8x) 0 var(--sp25x);
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		--shareLinkSize: var(--sp3x);
		--shareLinkRight: var(--sp6x);
		--shareLinkPadding: var(--sp2-5x);
		--socIconHeight: var(--sp8x);
		--socIconWidth: var(--sp4-5x);

		section {
			.back-btn {
				margin: var(--sp4x) 0 var(--sp9x);

				i {
					font-size: var(--sp6x);
					margin-right: var(--sp3x);
				}
			}

			.top {
				.infos {
					margin-right: var(--sp10x);

					.date {
						margin: var(--sp5x) 0 var(--sp11x);
					}
				}

				.imageCont {
					width: 50.5%;
					padding-top: 33.4%;
				}
			}

			.content {
				max-width: var(--sp101x);
				margin: var(--sp9x) auto var(--sp20x);

				p {
					margin-bottom: var(--sp3x);
				}

				figure {
					margin-bottom: var(--sp5x);
				}

				ul {
					margin-bottom: var(--sp5x);
					padding-left: var(--sp4x);

					li {
						padding-left: var(--sp4x);

						&:before {
							width: var(--sp2-5x);
							height: var(--sp2-5x);
						}

						&:not(:last-child) {
							margin-bottom: var(--sp3x);
						}
					}
				}

				ol {
					margin-bottom: var(--sp5x);
					padding-left: var(--sp4x);

					li {
						&:not(:last-child) {
							margin-bottom: var(--sp3x);
						}
					}
				}

				blockquote {
					padding-left: var(--sp4x);
				}
			}

			.related-title {
				margin-bottom: var(--sp5x);
			}
		}

		.btn-cont {
			margin: var(--sp7x) 0 var(--sp20x);
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeXS}) {
		--shareLinkSize: var(--sp2-5x);
		--shareLinkRight: var(--sp5x);
		--shareLinkPadding: var(--sp2x);
		--socIconHeight: var(--sp6-5x);
		--socIconWidth: var(--sp3-5x);

		section {
			.back-btn {
				margin: var(--sp4x) 0 var(--sp8x);

				i {
					font-size: var(--sp6x);
					margin-right: var(--sp3x);
				}
			}

			.top {
				.infos {
					margin-right: var(--sp10x);

					.date {
						margin: var(--sp4x) 0 var(--sp10x);
					}
				}

				.imageCont {
					width: 50.5%;
					padding-top: 33.4%;
				}
			}

			.content {
				max-width: var(--sp89x);
				margin: var(--sp8x) auto var(--sp18x);

				p {
					margin-bottom: var(--sp3x);
				}

				figure {
					margin-bottom: var(--sp5x);
				}

				ul {
					margin-bottom: var(--sp5x);
					padding-left: var(--sp4x);

					li {
						padding-left: var(--sp4x);

						&:before {
							width: var(--sp2-5x);
							height: var(--sp2-5x);
						}

						&:not(:last-child) {
							margin-bottom: var(--sp3x);
						}
					}
				}

				ol {
					margin-bottom: var(--sp5x);
					padding-left: var(--sp4x);

					li {
						&:not(:last-child) {
							margin-bottom: var(--sp3x);
						}
					}
				}

				blockquote {
					padding-left: var(--sp4x);
				}
			}

			.related-title {
				margin-bottom: var(--sp4x);
			}
		}

		.btn-cont {
			margin: var(--sp5x) 0 var(--sp18x);
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		section {
			.back-btn {
				margin: var(--sp3x) 0 var(--sp7x);

				i {
					font-size: var(--sp5x);
					margin-right: var(--sp3x);
				}
			}

			.top {
				.infos {
					margin-right: var(--sp3x);
					.social {
						.cont {
							.icon-copy {
								&:after {
									width: var(--sp3-5x);
									height: var(--sp6-5x);
								}
							}
						}
					}

					.date {
						margin: var(--sp3x) 0 var(--sp8x);
					}
				}

				.imageCont {
					width: 59.2%;
					padding-top: 38.9%;
				}
			}

			.content {
				max-width: var(--sp94x);
				margin: var(--sp7x) auto var(--sp15x);

				p {
					margin-bottom: var(--sp2x);
				}

				figure {
					margin-bottom: var(--sp3x);
				}

				ul {
					margin-bottom: var(--sp3x);
					padding-left: var(--sp3x);

					li {
						padding-left: var(--sp3x);

						&:before {
							width: var(--sp2-5x);
							height: var(--sp2-5x);
						}

						&:not(:last-child) {
							margin-bottom: var(--sp2x);
						}
					}
				}

				ol {
					margin-bottom: var(--sp3x);
					padding-left: var(--sp3x);

					li {
						&:not(:last-child) {
							margin-bottom: var(--sp2x);
						}
					}
				}

				blockquote {
					padding-left: var(--sp3x);
				}
			}

			.related-title {
				margin-bottom: var(--sp3x);
			}
		}

		.btn-cont {
			margin: var(--sp4x) 0 var(--sp15x);
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		section {
			.back-btn {
				margin: var(--sp3x) 0 var(--sp7x);

				i {
					font-size: var(--sp5x);
					margin-right: var(--sp3x);
				}
			}

			.top {
				flex-direction: column-reverse;

				.infos {
					margin-right: 0;
					margin-top: var(--sp7x);
					.social {
						.cont {
							.icon-copy {
								&:after {
									width: var(--sp3-5x);
									height: var(--sp6-5x);
								}
							}
						}
					}

					.date {
						margin: var(--sp3x) 0 var(--sp9x);
					}
				}

				.imageCont {
					width: 100%;
					padding-top: 66%;
				}
			}

			.content {
				max-width: unset;
				margin: var(--sp7x) auto var(--sp15x);

				p {
					margin-bottom: var(--sp2x);
				}

				figure {
					margin-bottom: var(--sp3x);
				}

				ul {
					margin-bottom: var(--sp3x);
					padding-left: var(--sp3x);

					li {
						padding-left: var(--sp3x);

						&:before {
							width: var(--sp2-5x);
							height: var(--sp2-5x);
						}

						&:not(:last-child) {
							margin-bottom: var(--sp2x);
						}
					}
				}

				ol {
					margin-bottom: var(--sp3x);
					padding-left: var(--sp3x);

					li {
						&:not(:last-child) {
							margin-bottom: var(--sp2x);
						}
					}
				}

				blockquote {
					padding-left: var(--sp3x);
				}
			}

			.related-title {
				margin-bottom: var(--sp3x);
			}
		}

		.btn-cont {
			margin: var(--sp4x) 0 var(--sp15x);
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		section {
			.back-btn {
				margin: var(--sp3x) 0 var(--sp6x);

				i {
					font-size: var(--sp5x);
					margin-right: var(--sp2x);
				}
			}

			.top {
				flex-direction: column-reverse;

				.infos {
					margin-right: 0;
					margin-top: var(--sp6x);
					.social {
						.cont {
							.icon-copy {
								&:after {
									width: var(--sp3-5x);
									height: var(--sp6-5x);
								}
							}
						}
					}

					.date {
						margin: var(--sp3x) 0 var(--sp9x);
					}
				}

				.imageCont {
					width: 100%;
					padding-top: 66%;
				}
			}

			.content {
				max-width: unset;
				margin: var(--sp6x) auto var(--sp12x);

				p {
					margin-bottom: var(--sp2x);
				}

				figure {
					margin-bottom: var(--sp3x);
				}

				ul {
					margin-bottom: var(--sp3x);
					padding-left: 0;

					li {
						padding-left: var(--sp3x);

						&:before {
							width: var(--sp2-5x);
							height: var(--sp2-5x);
						}

						&:not(:last-child) {
							margin-bottom: var(--sp2x);
						}
					}
				}

				ol {
					margin-bottom: var(--sp3x);
					padding-left: var(--sp2x);

					li {
						&:not(:last-child) {
							margin-bottom: var(--sp2x);
						}
					}
				}

				blockquote {
					padding-left: var(--sp3x);
				}
			}

			.related-title {
				margin-bottom: var(--sp3x);
			}
		}

		.related {
			flex-direction: column;
		}

		.btn-cont {
			margin: var(--sp3x) 0 var(--sp12x);
		}
	}
`
export default NewsIndividualStyle
